const makeStateFilter = (parentStateFilter, namespace) => (state) => parentStateFilter(state)[namespace];

export default makeStateFilter;
